module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h2"
    }
  }, [_vm._v("List of Illustrations")])]), _c('a', {
    attrs: {
      "id": "h2"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maps")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "h2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/06_introduction1#map1"
    }
  }, [_vm._v("1. The Whole Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter031#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. 14/15 June")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter033#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Allied Concentration Areas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter051#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. North of Charleroi")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter061#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. 16 June")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter071#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Quatre Bras Battlefield")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter073#figure1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. A French Battalion Assault Column")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter161#figure2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ordre Mixte")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-834fa94e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_illustrations.vue
// module id = 69
// module chunks = 0